import { render, staticRenderFns } from "./BulkProjectInfo.vue?vue&type=template&id=ed681b7a&"
import script from "./BulkProjectInfo.vue?vue&type=script&lang=ts&"
export * from "./BulkProjectInfo.vue?vue&type=script&lang=ts&"
import style0 from "./BulkProjectInfo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports